<template>
  <div class="page-index">

      <div v-for="filter in findFiltersItems(findFilters)">
        <div class="content-block-title filter-title">{{filter.groupName}}
          <a class="alert-text" @click="displayMessage(filter)" v-if="filter.tips">
            <img :src="questionUrl" style="width: .9rem"></img>
          </a>
        </div>
        <div class="list-block filter-block">
          <ul class="filter-block-ul">
            <li class="item-content filter-opts">
              <label class="label-checkbox checkbox-el filter-el" v-for="(item, inx) in filterItems(filter)">
                <input type="checkbox" :disabled="item.disabled" v-model="item.selected" v-on:change="queryHandler()">
                <div class="item-media checkbox filter-checkbox" :class="{selected: item.selected,disabled: item.disabled}"><div class="span-text">{{item.word}}</div></div>
              </label>

              <label class="label-checkbox checkbox-el filter-el" v-if="filter.filterItems.length>8 & !filter.expanded">
                <input type="checkbox" v-model="filter.expanded">
                <div class="item-media checkbox filter-checkbox more"><div class="span-text">更多...</div></div>
              </label>
            </li>
          </ul>
        </div>
      </div>
    <div v-if="findFilters.length>3 & !expend & finderyemian">
      <div style="text-align: center;color: #1e7be6;font-size: .7rem" @click="addmore">更多筛选项..</div>
    </div>
      <!--<div>-->
        <!--<div class="content-block-title filter-title">物种</div>-->
        <!--<div class="list-block filter-block">-->
          <!--<ul class="filter-block-ul">-->
            <!--<li class="item-content filter-opts">-->
              <!--<label class="label-checkbox checkbox-el filter-el">-->
                <!--<input type="checkbox" name="my-checkbox">-->
                <!--<div class="item-media checkbox filter-checkbox"><div class="span-text">human</div></div>-->
              <!--</label>-->
              <!--<label class="label-checkbox checkbox-el filter-el">-->
                <!--<input type="checkbox" name="my-checkbox">-->
                <!--<div class="item-media checkbox filter-checkbox"><div class="span-text">mouse</div></div>-->
              <!--</label>-->
              <!--<label class="label-checkbox checkbox-el filter-el">-->
                <!--<input type="checkbox" name="my-checkbox">-->
                <!--<div class="item-media checkbox filter-checkbox"><div class="span-text">rat</div></div>-->
              <!--</label>-->
            <!--</li>-->
          <!--</ul>-->
        <!--</div>-->
      <!--</div>-->

      <!--<div>-->
        <!--<div class="content-block-title filter-title">调控方式</div>-->
        <!--<div class="list-block filter-block">-->
          <!--<ul class="filter-block-ul">-->
            <!--<li class="item-content filter-opts">-->
              <!--<label class="label-checkbox checkbox-el filter-el">-->
                <!--<input type="checkbox" name="my-checkbox">-->
                <!--<div class="item-media checkbox filter-checkbox"><div class="span-text">RNAi</div></div>-->
              <!--</label>-->
              <!--<label class="label-checkbox checkbox-el filter-el">-->
                <!--<input type="checkbox" name="my-checkbox">-->
                <!--<div class="item-media checkbox filter-checkbox"><div class="span-text">SAM</div></div>-->
              <!--</label>-->
              <!--<label class="label-checkbox checkbox-el filter-el">-->
                <!--<input type="checkbox" name="my-checkbox">-->
                <!--<div class="item-media checkbox filter-checkbox"><div class="span-text">过表达</div></div>-->
              <!--</label>-->
            <!--</li>-->
          <!--</ul>-->
        <!--</div>-->
      <!--</div>-->

      <!--<div>-->
        <!--<div class="content-block-title filter-title">工具类型</div>-->
        <!--<div class="list-block filter-block">-->
          <!--<ul class="filter-block-ul">-->
            <!--<li class="item-content filter-opts">-->
              <!--<label class="label-checkbox checkbox-el filter-el">-->
                <!--<input type="checkbox" name="my-checkbox">-->
                <!--<div class="item-media checkbox filter-checkbox"><div class="span-text">慢病毒</div></div>-->
              <!--</label>-->
              <!--<label class="label-checkbox checkbox-el filter-el">-->
                <!--<input type="checkbox" name="my-checkbox">-->
                <!--<div class="item-media checkbox filter-checkbox"><div class="span-text">腺相关病毒</div></div>-->
              <!--</label>-->
              <!--<label class="label-checkbox checkbox-el filter-el">-->
                <!--<input type="checkbox" name="my-checkbox">-->
                <!--<div class="item-media checkbox filter-checkbox"><div class="span-text">腺病毒</div></div>-->
              <!--</label>-->
            <!--</li>-->
          <!--</ul>-->
        <!--</div>-->
      <!--</div>-->

      <!--<div>-->
        <!--<div class="content-block-title filter-title">启动子类型</div>-->
        <!--<div class="list-block filter-block">-->
          <!--<ul class="filter-block-ul">-->
            <!--<li class="item-content filter-opts">-->
              <!--<label class="label-checkbox checkbox-el filter-el">-->
                <!--<input type="checkbox" name="my-checkbox">-->
                <!--<div class="item-media checkbox filter-checkbox"><div class="span-text">广谱启动子</div></div>-->
              <!--</label>-->
              <!--<label class="label-checkbox checkbox-el filter-el">-->
                <!--<input type="checkbox" name="my-checkbox">-->
                <!--<div class="item-media checkbox filter-checkbox"><div class="span-text">组织特异性启动子</div></div>-->
              <!--</label>-->
            <!--</li>-->
          <!--</ul>-->
        <!--</div>-->
      <!--</div>-->

      <!--<div>-->
        <!--<div class="content-block-title filter-title">细胞/组织</div>-->
        <!--<div class="list-block filter-block">-->
          <!--<ul class="filter-block-ul">-->
            <!--<li class="item-content filter-opts">-->
              <!--<label class="label-checkbox checkbox-el filter-el">-->
                <!--<input type="checkbox" name="my-checkbox">-->
                <!--<div class="item-media checkbox filter-checkbox"><div class="span-text">神经组织</div></div>-->
              <!--</label>-->
              <!--<label class="label-checkbox checkbox-el filter-el">-->
                <!--<input type="checkbox" name="my-checkbox">-->
                <!--<div class="item-media checkbox filter-checkbox"><div class="span-text">肌肉</div></div>-->
              <!--</label>-->
              <!--<label class="label-checkbox checkbox-el filter-el">-->
                <!--<input type="checkbox" name="my-checkbox">-->
                <!--<div class="item-media checkbox filter-checkbox"><div class="span-text">骨骼肌</div></div>-->
              <!--</label>-->
              <!--<label class="label-checkbox checkbox-el filter-el">-->
                <!--<input type="checkbox" name="my-checkbox">-->
                <!--<div class="item-media checkbox filter-checkbox"><div class="span-text">肝脏</div></div>-->
              <!--</label>-->
              <!--<label class="label-checkbox checkbox-el filter-el">-->
                <!--<input type="checkbox" name="my-checkbox">-->
                <!--<div class="item-media checkbox filter-checkbox"><div class="span-text">肺</div></div>-->
              <!--</label>-->
              <!--<label class="label-checkbox checkbox-el filter-el">-->
                <!--<input type="checkbox" name="my-checkbox">-->
                <!--<div class="item-media checkbox filter-checkbox"><div class="span-text">胰腺</div></div>-->
              <!--</label>-->
              <!--<label class="label-checkbox checkbox-el filter-el">-->
                <!--<input type="checkbox" name="my-checkbox">-->
                <!--<div class="item-media checkbox filter-checkbox"><div class="span-text">内皮细胞</div></div>-->
              <!--</label>-->
              <!--<label class="label-checkbox checkbox-el filter-el">-->
                <!--<input type="checkbox" name="my-checkbox">-->
                <!--<div class="item-media checkbox filter-checkbox"><div class="span-text">脂肪组织</div></div>-->
              <!--</label>-->
              <!--<label class="label-checkbox checkbox-el filter-el">-->
                <!--<input type="checkbox" name="my-checkbox">-->
                <!--<div class="item-media checkbox filter-checkbox"><div class="span-text">角质层</div></div>-->
              <!--</label>-->
              <!--<label class="label-checkbox checkbox-el filter-el">-->
                <!--<input type="checkbox" name="my-checkbox">-->
                <!--<div class="item-media checkbox filter-checkbox"><div class="span-text">视网膜</div></div>-->
              <!--</label>-->
            <!--</li>-->
          <!--</ul>-->
        <!--</div>-->
      <!--</div>-->

      <!--<div>-->
        <!--<div class="content-block-title filter-title">功能应用</div>-->
        <!--<div class="list-block filter-block">-->
          <!--<ul class="filter-block-ul">-->
            <!--<li class="item-content filter-opts">-->
              <!--<label class="label-checkbox checkbox-el filter-el">-->
                <!--<input type="checkbox" name="my-checkbox">-->
                <!--<div class="item-media checkbox filter-checkbox"><div class="span-text">光遗传</div></div>-->
              <!--</label>-->
              <!--<label class="label-checkbox checkbox-el filter-el">-->
                <!--<input type="checkbox" name="my-checkbox">-->
                <!--<div class="item-media checkbox filter-checkbox"><div class="span-text">化学遗传</div></div>-->
              <!--</label>-->
              <!--<label class="label-checkbox checkbox-el filter-el">-->
                <!--<input type="checkbox" name="my-checkbox">-->
                <!--<div class="item-media checkbox filter-checkbox"><div class="span-text">钙指示</div></div>-->
              <!--</label>-->
            <!--</li>-->
          <!--</ul>-->
        <!--</div>-->
      <!--</div>-->


</div>
</template>

<script>
//  import emkt from '../../emkt'
  import $ from 'jquery'
  export default {
    props: ['findFilters', 'finderyemian'],
    data () {
      return {
        questionUrl: '../../../static/img/question.png',
        attrurl: '../../../static/filters/',
        expend: false
      }
    },
    created () {
      this.fetchData()
    },
    warch: {
      'finderyemian': function (val) {
        console.log(val)
      }
    },
    methods: {
      queryHandler () {
        this.$emit('finderFilterSearch', this.findFilters)
      },
      fetchData () {
      },
      displayMessage (filter) {
        var content = '<div id="lottery"><img style="width: 14rem;height: 14rem;"' + 'src=' + this.attrurl + filter.tips + '></div>'
        $.modal({
          text: content,
          buttons: [ {
            text: '确定',
            onClick: function () {
            }
          }]
        })
        $('.modal').css({'width': '15rem', 'height': '18rem', 'margin-left': '-7.7rem'})
        $('.modal-buttons').css({'height': '1.5rem'})
        $('.modal-button').css({'line-height': '1.5rem'})
        $('.modal-inner').css({'padding': '.55rem'})
      },
      filterItems (filter) {
        if (filter.expanded) {
          return filter.filterItems
        }
        if (!this.finderyemian) {
          return filter.filterItems
        }
        return filter.filterItems.slice(0, 8)
      },
      findFiltersItems (findFilters) {
        if (this.expend || !this.finderyemian) {
          return findFilters
        }
        return findFilters.slice(0, 3)
      },
      addmore () {
        this.expend = true
      }

    }
  }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  .checkbox-el {
    display: inline-block;
    text-align: left;
  }
  .checkbox {
    display: inline-block;
    text-decoration: none;
    color: #878787; /*8b8b8b*/
    font-weight: normal;
    font-style: normal;
    font-size: .6rem;
    /*font-weight:200;*/
    line-height: 1;
    background-color: #f9f9f9; /*#f0f0f0*/
    padding: 0.5em;
    border-radius:.25rem;
    text-align: center;
    /*width: 3rem;*/

  }


  /*搜索选项区*/
  .filter-title{
    margin-top: 0.3rem;
    margin-bottom: 0rem;
    margin-left: 0.5rem;
    margin-right: 0.5rem;
    color: #1e7be6;
    font-weight: normal;
    font-style: normal;
    font-size: 0.6rem;
  }
  .filter-block{
    margin-top: 0.1rem;
    margin-bottom: 0.5rem;
  }
  .filter-block-ul{
    border-top: none;
    border-bottom: none;
  }
  .filter-opts{
    margin-left: 0rem;
    padding-left: 0.5rem;
    padding-right: 0.5rem;
    padding-top: 0.0rem;
    padding-bottom: 0.0rem;

    min-height: 1rem;
    display: block;
    vertical-align: center;
  }
  .filter-el {
    margin-top: 0.2rem;
    margin-bottom: 0.1rem;
    margin-right: 0.1rem;
    margin-left: 0.1rem;
  }
  .filter-checkbox {
    min-width: 3.8rem;
  }

  .checkbox.selected {
    /*color: #1E90FF;*/ /*#4169E1;*/
    background-color: rgba(105, 162, 255, 0.21);
  }
  .checkbox.disabled {
    color: #dcdcdc;
  }
  .checkbox.more {
    background-color: rgba(249, 249, 249, 0.33);
  }
</style>



// WEBPACK FOOTER //
// FinderFilter.vue?18a03fca